import { Box, Loader } from 'braid-design-system';
import React from 'react';

import FormCard from '../../shared/FormCard/FormCard';

import * as styles from './StaticHoldingPage.css';

const StaticHoldingPage = () => (
  <FormCard>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={styles.minHeight}
    >
      <Loader size="large" />
    </Box>
  </FormCard>
);

export default StaticHoldingPage;
